export default __webpack_public_path__ + "static/media/sorat-bg.06ae0c8f.png";